

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertConfirmComponent } from './alert-confirm.component';
import { AlertConfirmService } from '../../services/alert-confirm.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ModulosDeFormulario } from 'src/app/utils/formsModules';


@NgModule({
  declarations: [
    AlertConfirmComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    MatProgressSpinnerModule,
    ModulosDeFormulario
  ],
  exports: [
    AlertConfirmComponent
  ], 
  providers: [
    AlertConfirmService
  ]
})

export class AlertConfirmModule { }